@if (appearance === SkeletonAppearanceEnum.heading) {
  <span class="is-loader is-heading is-title {{size ? 'is-size-' + size : ''}}"
    [attr.aria-label]="ariaLabel"
    aria-busy="true"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuetext]="loadingText"
    role="progressbar"
    tabindex="0"
    [ngClass]="{
      'is-progress': animation === SkeletonAnimationEnum.progress,
      'is-progress-dark': animation === SkeletonAnimationEnum.progressDark,
      'is-pulse': animation === SkeletonAnimationEnum.pulse
    }"
  ></span>
  <span class="is-loader is-heading is-subtitle {{size ? 'is-size-' + size : ''}}"
    [attr.aria-label]="ariaLabel"
    aria-busy="true"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuetext]="loadingText"
    role="progressbar"
    tabindex="0"
    [ngClass]="{
      'is-progress': animation === SkeletonAnimationEnum.progress,
      'is-progress-dark': animation === SkeletonAnimationEnum.progressDark,
      'is-pulse': animation === SkeletonAnimationEnum.pulse
    }"
  ></span>
  @if (count > 0) {
    <span
      class="is-loader"
      [attr.aria-label]="ariaLabel"
      aria-busy="true"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuetext]="loadingText"
      role="progressbar"
      tabindex="0"
      [ngClass]="{
        'is-progress': animation === SkeletonAnimationEnum.progress,
        'is-progress-dark': animation === SkeletonAnimationEnum.progressDark,
        'is-pulse': animation === SkeletonAnimationEnum.pulse
      }"
    ></span>
  }
}

@if (count > 0) {
  @for (item of items; track $index) {
    <span
      class="is-loader {{size ? 'is-size-' + size : ''}} {{count === 1 ? 'is-single' : ''}} {{ratio ? 'is-' + ratio : 'is-4_3'}}"
      [attr.aria-label]="ariaLabel"
      aria-busy="true"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuetext]="loadingText"
      role="progressbar"
      tabindex="0"
      [ngClass]="{
        'is-media': appearance === SkeletonAppearanceEnum.media,
        'is-line': appearance === SkeletonAppearanceEnum.line,
        'is-circle': appearance === SkeletonAppearanceEnum.circle,
        'is-square': appearance === SkeletonAppearanceEnum.square,
        'is-progress': animation === SkeletonAnimationEnum.progress,
        'is-progress-dark': animation === SkeletonAnimationEnum.progressDark,
        'is-pulse': animation === SkeletonAnimationEnum.pulse
      }"
    ></span>
  }
}
